import {AbstractProfileFormComponent} from "../../abstract/abstract-profile/abstract-profile-form.component";
import {Component} from "@angular/core";
import {ProfileFormTemplateProviders} from "../../../core/templates/profile-form.template.providers";
import {BFOnFormLoadComplete, BFOnValueChange} from "../../../core/interfaces/sdk-profile-hooks.interface";
import {IValueChange} from "../../../core/interfaces/form-value-change.interface";
import {ProfileLayoutType} from "../../enums/profile-layout-type.enum";

@Component({
  selector: 'app-override-stp',
  templateUrl: '../../../core/templates/profile-form.template.html',
  styleUrls: ['../../../core/templates/profile-form.template.scss'],
  providers: ProfileFormTemplateProviders
})
export class OverrideStpComponent extends AbstractProfileFormComponent implements BFOnFormLoadComplete, BFOnValueChange {

  fgppFormLoadComplete(): void {
    if (this.layoutMode === ProfileLayoutType.CREATE) {
      const type = this.formMgr.get('PREVENT_STP-TYPE').getValue();
      this.disableSubType(type);
    }
  }

  disableSubType(type: string) {
    if (type === '193') {
      this.formMgr.get('PREVENT_STP-SUB_TYPE').disable().reset();
    } else {
      this.formMgr.get('PREVENT_STP-SUB_TYPE').enable();
    }
  }

  fgppValueChanges(change: IValueChange): void {
    if (change.control === 'PREVENT_STP-TYPE') {
      const type = this.formMgr.get('PREVENT_STP-TYPE').getValue();
      this.disableSubType(type);
    }
    if (change.control === 'PREVENT_STP-MSG_STATUS') {
      const messageStatus = this.formMgr.get('PREVENT_STP-MSG_STATUS').getValue();
      if (messageStatus) {
        const drilldownData = this.getDrilldownData('PREVENT_STP-MSG_STATUS');
        if (drilldownData) {
          this.formMgr.get('STATUSES-V_ALIAS').setValue(drilldownData['STATUSES.ALIAS']);
        }
      }
    }
  }
}
